import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/common/ScrollReveal';

export default function CTASection() {
  return (
    <section id="contact" className="w-full bg-gradient-to-b from-[#f2f4ff] via-[#eaeeff] to-[#f4f2ff]">
      <ScrollReveal animation="fade-up" className="max-w-3xl mx-auto px-4 md:px-6 py-16 md:py-20 text-center">
        <h2 className="text-2xl md:text-[32px] font-bold text-[#1f2329] tracking-tight">Great programs run on LoyaltyBridge</h2>
        <p className="mt-2 text-sm text-[#646a73]">Talk to our team and we&apos;ll help you design and launch your loyalty program.</p>
        <div className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-[#646a73]">
          {['Launch in a day', 'Industry best practices', 'Measurable repeat revenue'].map((t) => (
            <span key={t} className="inline-flex items-center gap-1.5">
              <i className="ri-checkbox-circle-fill text-[#5b6cff]" /> {t}
            </span>
          ))}
        </div>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/signup"
            className="w-40 h-11 inline-flex items-center justify-center rounded-full bg-gradient-to-r from-[#7b8cff] to-[#5b6cff] text-white text-sm font-semibold shadow-[0_10px_24px_-10px_rgba(91,108,255,0.9)] hover:brightness-110 transition-all"
          >
            Start free
          </Link>
          <Link
            to="/login"
            className="w-40 h-11 inline-flex items-center justify-center rounded-full border border-[#5b6cff] text-[#5b6cff] bg-white/60 text-sm font-semibold hover:bg-white transition-colors"
          >
            Sign in
          </Link>
        </div>
      </ScrollReveal>
    </section>
  );
}
